export const typeMapApiName = {
    1: 'rateOneMonth',
    2: 'rateThreeMonth',
    3: 'rateHalfYear',
    4: 'rateOneYear',
    5: 'rateThreeYear',
    6: 'rateSinceExist',
    7: 'rateYearMonth',
    8: 'rateYear7days'
};

export const INCREASEENUM = {
    '1': {
        tag: '近一月涨幅',
        tagHk: '近一月升幅',
        tagEn: '% Change in 1 Mth',
        url: '/api/fund-increase/rate-1-month'
    },
    '2': {
        tag: '近三月涨幅',
        tagHk: '近三月升幅',
        tagEn: '% Change in 3 Mth',
        url: '/api/fund-increase/rate-3-month'
    },
    '3': {
        tag: '近半年涨幅',
        tagHk: '近半年升幅',
        tagEn: '% Change in 6 Mth',
        url: '/api/fund-increase/rate-6-month'
    },
    '4': {
        tag: '近一年涨幅',
        tagHk: '近一年升幅',
        tagEn: '% Change in 1 Yr',
        url: '/api/fund-increase/rate-1-year'
    },
    '5': {
        tag: '近三年涨幅',
        tagHk: '近三年升幅',
        tagEn: '% Change in 3 Yr',
        url: '/api/fund-increase/rate-3-year'
    },
    '6': {
        tag: '成立以来涨幅',
        tagHk: '成立以來升幅',
        tagEn: '% Change Since Inception',
        url: '/api/fund-increase/rate-all'
    },
    '7': {
        tag: '近一月年化',
        tagHk: '近一月年化',
        tagEn: 'Last 1-Mth Yield',
        url: '/api/fund-increase/year-rate-month'
    },
    '8': {
        tag: '近七日年化',
        tagHk: '近七日年化',
        tagEn: 'Last 7-Day Yield',
        url: '/api/fund-increase/year-rate-7-day'
    }
};
